/* eslint-disable react/jsx-props-no-spreading */
import { SVGProps } from 'react';

const PositionsHomeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="16"
    viewBox="0 0 14 16"
    fill="none"
    {...props}
    data-palette="PositionsHomeIcon">
    <path
      d="M2.35653 8.96696L1.44653 8.00696L5.90653 3.46696L4.17653 1.75696L11.4165 0.886963L10.4965 7.99696L8.78653 6.41696L5.58653 9.36696L3.95653 7.86696L2.91653 14.847L10.0765 13.957L8.46653 12.327L12.9765 7.86696L12.0165 6.87696"
      stroke="var(--main-text-primary)"
      strokeWidth="1"
      strokeLinecap="round"
      fill="none"
    />
  </svg>
);

export default PositionsHomeIcon;
